import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { logoGoogle } from 'ionicons/icons';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../../firebaseConfig';

const GoogleLoginButton: React.FC = () => {
  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      // Redirect to the main page or show a success message
    } catch (error) {
      console.error('Error logging in with Google:', error);
      // Show an error message
    }
  };

  return (
    <IonButton onClick={handleGoogleLogin} expand="block">
      <IonIcon icon={logoGoogle} slot="start" />
      Login with Google
    </IonButton>
  );
};

export default GoogleLoginButton;
